import { services } from '@broadleaf/admin-components';
import { AuroraExternalGridCollection } from 'app/form/components/AuroraExternalGridCollection';
import { AuroraActionListGrid } from 'app/form/components/ActionListGrid/AuroraActionListGrid';
const { ComponentRegistrar } = services;

ComponentRegistrar.registerExternalComponent(
  'EXTERNAL_GRID',
  AuroraExternalGridCollection
);

ComponentRegistrar.registerComponent('blActionListGrid', AuroraActionListGrid);
